import {
    faPlus,
    faExchangeAlt,
    faToggleOn,
    faCut,
    faLayerGroup,
    faPencilAlt,
} from '@fortawesome/free-solid-svg-icons';
import { NewProgramForm } from './newProgram';
import { MergeProgramsForm } from './mergePrograms';
import { ConsolidateProgramsForm } from './consolidatePrograms';
import { ChangeDetailsForm } from './changeDetails';
import { ChangeStatusForm } from './changeStatus';
import { SplitProgramForm } from './splitProgram';

export const programRequestTypeRegistry = {
    createNew: {
        typeId: '1',
        label: 'Create New Program',
        description: 'All fields for a brand-new program',
        icon: faPlus,
        Form: NewProgramForm,
    },
    merge: {
        typeId: '8',
        label: 'Merge Two Programs',
        description: 'Combine one program into another',
        icon: faExchangeAlt,
        Form: MergeProgramsForm,
    },
    changeStatus: {
        typeId: '6',
        label: 'Change Status',
        description: 'Eliminate, suspend, or reinstate',
        icon: faToggleOn,
        Form: ChangeStatusForm,
    },
    split: {
        typeId: '7',
        label: 'Split a Program',
        description: 'Divide one program into two',
        icon: faCut,
        Form: SplitProgramForm,
    },
    consolidate: {
        typeId: '10',
        label: 'Consolidate Programs',
        description: 'Many programs → one new program',
        icon: faLayerGroup,
        Form: ConsolidateProgramsForm,
    },
    changeDetails: {
        typeId: '12',
        label: 'Change Details',
        description: 'Name, CIP, hours, delivery, etc.',
        icon: faPencilAlt,
        Form: ChangeDetailsForm,
    },
};

// Existing granular detail-change requests are edited through the consolidated
// Change Details slice while retaining their server-side request type.
const requestTypeAliases = {
    2: 'changeDetails',
    3: 'changeDetails',
    4: 'changeDetails',
    5: 'changeDetails',
    9: 'changeDetails',
    11: 'changeDetails',
};

export const getRequestTypeKey = (
    typeId,
    registry = programRequestTypeRegistry
) => {
    const canonicalKey = Object.keys(registry).find(
        key => registry[key].typeId === String(typeId)
    );
    return canonicalKey ?? requestTypeAliases[String(typeId)] ?? null;
};
